module.exports = __webpack_public_path__ + "img/07.e988f8e1.png";